// import styled from 'styled-components';
import { Box, Typography, Grid, Chip, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { IoIosAddCircleOutline } from "react-icons/io";
import styled from 'styled-components';
import BASE_API_URL from '../apis/index';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import CompanyCard from '../components/CompanyCard';
import Carousel from "react-bootstrap/Carousel"; // Bootstrap Carousel
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap styles
import CheckIcon from "@mui/icons-material/Check";

const UserCompanies = () => {
  const [userCompanies, setUserCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await axios.get(`${BASE_API_URL}/api/seller/companies`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUserCompanies(res.data || []);
      } catch (err) {
        console.error('Error fetching user companies short data: ', err);
      }
    };
    fetchCompanies();
  }, []);

  return (
    <div className='container p-3'>
      <Typography variant="h4" gutterBottom>
        Your Companies
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        You have <strong>{userCompanies.length}</strong> companies added.
      </Typography>

      {/* <Grid container spacing={2}>
        {userCompanies.map((compData) => (
          <CompanyCard compData={compData} linkType="dashboard" />
        ))}
      </Grid> */}

      <Grid container spacing={2}>
        {userCompanies.map((compData, idx) => (
          <CompShortInfoSec key={idx} company={compData} linkType="dashboard" />
        ))}
      </Grid>

      <NoCompSec />
    </div>
  );
};

export default UserCompanies;

const NoCompSec = () => {
  return (
    <Wrapper className='NoCompSec container mt-4'>
      <div className="innerSec d-flex flex-column align-items-center justify-content-center ">
        <Link to={`/user-company-register`} className='text-decoration-none txt_color_primary txt_color_primary_hvr text-center'>
          <IoIosAddCircleOutline />
          <h6> Add Compnany</h6>
        </Link>
      </div>
    </Wrapper>
  )
}

const CompShortInfoSec = ({ company, linkType }) => {
  const linkHref =
    linkType === "public"
      ? `/company-details?compId=${company.id}`
      : `/user-company-details?compId=${company.id}`;

  return (
    <Section className="p-3 container border rounded-4">
      <FlexRow>
        <LeftSide className='d-flex flex-column justify-content-center'>
          <CompLogo>
            <img
              src={`${BASE_API_URL}/uploads/user_comp_docs/${company.company_logo}`}
              alt="Company Logo"
            />
          </CompLogo>
          <Typography variant="h5" className="txt_color_primary">
            {company.company_name}
          </Typography>
          <Box mt={1} mb={1}>
            {JSON.parse(company.company_types).map((type) => (
              <Chip
                key={type}
                label={type}
                color="warning"
                variant="outlined"
                sx={{ mr: 1 }}
                className="rounded"
              />
            ))}
          </Box>

          <Typography variant="body2" mt={2}>
            GST Number: {company.gst_number}
          </Typography>

          <div className='d-flex mt-3 gap-2'>
            <AlertBox
            icon={<CheckIcon fontSize="inherit" />}
            severity="warning"
          >
            Status: <strong>{company.status}</strong>
          </AlertBox>

          <CardLink href={linkHref}>
            View Details
          </CardLink>
          </div>
        </LeftSide>

        <RightSide>
          {company.company_images && (
            <Carousel>
              {JSON.parse(company.company_images).map((img, idx) => (
                <Carousel.Item key={idx}>
                  <img
                    className="d-block w-100"
                    src={`${BASE_API_URL}/uploads/user_comp_docs/${img}`}
                    alt={`company-img-${idx}`}
                    style={{
                      maxHeight: "300px",
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          )}
        </RightSide>
      </FlexRow>
    </Section>
  )
}

const Wrapper = styled.div`
  border: 4px dashed #f896221c;
  border-radius: 20px;
  height: 200px;
  width: 100%;
  padding: 10px;
  .innerSec{
    background: #f896221c;
    border-radius: 10px;
    height: 100%;
    svg{
      font-size: 50px;
      color: var(--secondary-color)
    }
}
`

const AlertBox = styled(Alert)`
  width: 320px;
`;

const Section = styled(Box)`
  margin-bottom: 30px;
`;

const LeftSide = styled(Box)`
  flex: 1;
`;

const RightSide = styled(Box)`
  flex: 1;
`;

const FlexRow = styled(Box)`
  display: flex;
  align-items: flex-center;
  gap: 20px;
`;

const CompLogo = styled.div`
  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
`;

const CardLink = styled.a`
  width: 150px;
  border: 1px solid var(--secondary-color);
  padding: 10px 25px; 
  color: var(--secondary-color);
  font-size: 0.8rem;
  text-decoration: none;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.5s;
  &:hover{
    background: var(--secondary-color);
    color: white;
  }
`;

